import {createChangeRequestStoreKey} from './createChangeRequestStoreKey';

export const removeChangeRequestInLocalStore = (id: string, workId: string) => {
  const key = createChangeRequestStoreKey(id, workId);
  localStorage.removeItem(key);
};
